import { graphql, useStaticQuery } from 'gatsby';

import { ILibraryMeetingPlaceDictionary } from '../queries/fragments/libraryMeetingPlaceDictionary';

export const useGetLibraryDictionary = (
  locale: string,
): ILibraryMeetingPlaceDictionary | undefined => {
  const data: {
    allContentfulLibraryMeetingPlaceDictionary: {
      nodes: ILibraryMeetingPlaceDictionary[];
    };
  } = useStaticQuery(
    graphql`
      query {
        allContentfulLibraryMeetingPlaceDictionary {
          nodes {
            ...LibraryMeetingPlaceDictionary
          }
        }
      }
    `,
  );

  return data.allContentfulLibraryMeetingPlaceDictionary.nodes.find(
    (dict) => dict.node_locale === locale,
  );
};
